export const SALON = {
  name: "Haarstudio Nes",
  tagline: "Meisterin für Ihr Haar • Glessen",
  street: "Heidenpfuhl 7",
  city: "50129 Glessen",
  phoneDisplay: "02238 43 770",
  phoneHref: "tel:+49223843770",
  hours: [
    { days: "Dienstag – Freitag", time: "9:00 – 18:00 Uhr" },
    { days: "Samstag", time: "9:00 – 14:00 Uhr" },
    { days: "Sonntag & Montag", time: "geschlossen" },
  ],
  emailPlaceholder: "nezahatozan62@gmail.com",
  emailHref: "mailto:nezahatozan62@gmail.com",
  instagramUrl: "https://www.instagram.com/haarstudiones/",
  instagramHandle: "@haarstudiones",
};

export const NAV_ITEMS = [
  { to: "/", label: "Start" },
  { to: "/leistungen", label: "Leistungen" },
  { to: "/frisuren", label: "Frisuren" },
  { to: "/team", label: "Über Nes" },
  { to: "/galerie", label: "Galerie" },
  { to: "/karriere", label: "Karriere" },
  { to: "/kontakt", label: "Kontakt" },
];

export const SERVICES = [
  "Balayage",
  "Highlights / Foliensträhnen",
  "Haare färben",
  "Ansatzfarbe",
  "Glossing",
  "Damenhaarschnitt",
  "Herrenhaarschnitt",
  "Maschinenschnitt (Herren)",
  "Bart trimmen",
  "Kinderhaarschnitt",
  "Lockiges Haar (Schnitt & Pflege)",
  "Haare flechten",
  "Hochsteckfrisur",
  "Haar-Extensions",
  "Dauerwelle",
  "Kur & Intensivpflege",
  "Waschen & Föhnen",
  "Brauen & Wimpern",
  "Kostenlose Beratung",
];

export const TIME_SLOTS = [
  "09:00", "09:30", "10:00", "10:30", "11:00", "11:30",
  "12:00", "12:30", "13:00", "13:30", "14:00", "14:30",
  "15:00", "15:30", "16:00", "16:30", "17:00", "17:30",
];

export const IMAGES = {
  storefront: "/images/schaufenster.jpeg",
  nes: "/images/nes-inhaberin-2.webp",
  balayageReal: "/images/highlights-echt.jpeg",
  highlightsReal: "/images/balayage-echt.jpeg",
  wavesReal: "/images/ergebnis-wellen.jpeg",
  mensCutReal: "/images/herrenschnitt-echt.jpeg",
  updoReal: "/images/hochsteckfrisur-echt.jpeg",
  hero: "https://images.pexels.com/photos/7750137/pexels-photo-7750137.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  balayage: "https://images.unsplash.com/photo-1638064432604-8da1fc75de09?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHw0fHxiYWxheWFnZSUyMGhhaXIlMjBibG9uZGUlMjBjYXJhbWVsfGVufDB8fHx8MTc5MjkyODMwNXww&ixlib=rb-4.1.0&q=85",
  stylist: "https://images.unsplash.com/photo-1629397685944-7073f5589754?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxoYWlyJTIwc3R5bGlzdCUyMGF0JTIwd29yayUyMHNhbG9ufGVufDB8fHx8MTc5MjkyODMwNXww&ixlib=rb-4.1.0&q=85",
  mens: "https://images.pexels.com/photos/7518732/pexels-photo-7518732.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  kids: "https://images.pexels.com/photos/36741613/pexels-photo-36741613.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  curly: "https://images.pexels.com/photos/30265797/pexels-photo-30265797.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  extensions: "https://images.unsplash.com/photo-1634449571017-5fecfd26ad76?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwzfHxoYWlyJTIwZXh0ZW5zaW9ucyUyMHN0eWxpbmd8ZW58MHx8fHwxNzkyOTI4MzA1fDA&ixlib=rb-4.1.0&q=85",
  team1: "https://images.unsplash.com/photo-1662850886700-4ec19bd30d11?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxmcmllbmRseSUyMGhhaXIlMjBzdHlsaXN0JTIwcG9ydHJhaXR8ZW58MHx8fHwxNzkyOTI4MzA1fDA&ixlib=rb-4.1.0&q=85",
  team2: "https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxmcmllbmRseSUyMGhhaXIlMjBzdHlsaXN0JTIwcG9ydHJhaXR8ZW58MHx8fHwxNzkyOTI4MzA1fDA&ixlib=rb-4.1.0&q=85",
};

export const LEISTUNGEN = [
  {
    category: "Schneiden",
    note: "Präzise Schnitte für jedes Alter",
    items: [
      { name: "Damenhaarschnitt", desc: "Vom klassischen Bob bis zum modernen Stufenschnitt – inklusive Beratung. Mit Waschen und Föhnen 48 €. Ideal für alle, die einen Schnitt wünschen, der zur Gesichtsform und zum Alltag passt.", duration: "ca. 45–60 Min.", price: "ab 35 €" },
      { name: "Herrenhaarschnitt", desc: "Saubere Konturen, klassische Schnitte oder moderne Fades – schnell und unkompliziert. Mit Waschen und Föhnen 27 €.", duration: "ca. 30 Min.", price: "22 €" },
      { name: "Maschinenschnitt (Herren)", desc: "Der schnellste Weg zu frischen Konturen – präzise mit der Maschine, ohne lange Wartezeit.", duration: "ca. 15–20 Min.", price: "17 €" },
      { name: "Bart trimmen", desc: "Bart in Form gebracht: Konturen sauber, Länge gepflegt. Schneller Zwischen-Termin ohne große Planung.", duration: "ca. 15 Min.", price: "12 €" },
      { name: "Kinderhaarschnitt", desc: "Geduldig und in entspannter Atmosphäre – auch für die Kleinsten ein schönes Erlebnis. Für Kinder bis 13 Jahre.", duration: "ca. 20–30 Min.", price: "18 €" },
    ],
  },
  {
    category: "Farbe",
    note: "Natürliche Nuancen, gesundes Haar",
    items: [
      { name: "Balayage", desc: "Freihand aufgemalte Farbverläufe für einen natürlichen, sonnengeküssten Look. Geeignet für alle, die weiche Übergänge ohne sichtbaren Ansatz lieben.", duration: "ca. 2–4 Std.", price: "ab 120 €" },
      { name: "Highlights / Foliensträhnen", desc: "Feine Strähnen für mehr Dimension und Leuchtkraft. Faire Abrechnung pro Folie: bis 30 Strähnen je 3 €, danach je 2,50 €. Kammsträhnen pauschal 45 €.", duration: "ca. 1,5–2,5 Std.", price: "3 € pro Strähne" },
      { name: "Ansatzfarbe", desc: "Frischer Ansatz zwischen den großen Farb-Terminen – deckt Grau zuverlässig ab und hält Ihre Nuance gleichmäßig. Schneller Termin, ideal alle vier bis sechs Wochen.", duration: "ca. 45–60 Min.", price: "45–50 €" },
      { name: "Haare färben", desc: "Komplette Farbveränderung in Ihrer Wunschnuance. Wir beraten Sie ausführlich zu Haltbarkeit und Pflege.", duration: "ca. 1–2 Std.", price: "ab 65 €" },
      { name: "Glossing", desc: "Das Glanz-Finish für zwischendurch: frischt die Farbe auf und versiegelt die Haaroberfläche für seidigen Glanz.", duration: "ca. 30 Min.", price: "20 €" },
    ],
  },
  {
    category: "Locken & Form",
    note: "Sprungkraft und Definition",
    items: [
      { name: "Lockiges Haar (Schnitt & Pflege)", desc: "Spezielle Schnitttechniken für Naturlocken, damit jede Locke perfekt fällt – reiner Formenschnitt für Ihren Lockentyp.", duration: "ca. 30 Min.", price: "ab 35 €" },
      { name: "Dauerwelle", desc: "Moderne, schonende Dauerwelle für langanhaltendes Volumen und natürliche Wellen. Als Komplett-Paket inklusive Schnitt, Kur und Föhnen 110 €.", duration: "ca. 2–2,5 Std.", price: "ab 70 €" },
    ],
  },
  {
    category: "Styling",
    note: "Für besondere Anlässe",
    items: [
      { name: "Haare flechten", desc: "Vom schlichten Alltags-Zopf bis zur festlichen Flechtfrisur – individuell auf Ihren Anlass abgestimmt.", duration: "ca. 30–60 Min.", price: "ab 25 €" },
      { name: "Hochsteckfrisur", desc: "Elegante Hochsteckfrisuren für Hochzeit, Konfirmation und besondere Anlässe – darauf ist Nes spezialisiert. Auf Wunsch mit Probe-Termin, damit am großen Tag alles sitzt.", duration: "ca. 45–75 Min.", price: "nach Absprache" },
      { name: "Waschen & Föhnen", desc: "Die kleine Auszeit für zwischendurch: verwöhnende Wäsche und schönes Föhnen – für Frische ohne Schnitt.", duration: "ca. 30–45 Min.", price: "26 €" },
    ],
  },
  {
    category: "Augen",
    note: "Der Blickfang",
    items: [
      { name: "Brauen färben", desc: "Ausdrucksstarke Brauen in wenigen Minuten – für einen wachen, gepflegten Blick ohne tägliches Nachzeichnen.", duration: "ca. 15 Min.", price: "10 €" },
      { name: "Wimpern färben", desc: "Dunkle, dicht wirkende Wimpern ganz ohne Mascara – ideal auch für Urlaub und Sport.", duration: "ca. 20 Min.", price: "15 €" },
      { name: "Brauen zupfen", desc: "Die Brauen sauber in Form gezupft – der schnelle Frische-Kick, auch gern kombiniert mit Färben.", duration: "ca. 15 Min.", price: "ab 10 €" },
    ],
  },
  {
    category: "Länge & Pflege",
    note: "Verwandlung und intensive Pflege",
    items: [
      { name: "Haar-Extensions", desc: "Hochwertige Echthaar-Extensions für mehr Länge und Fülle – nahtlos eingearbeitet. Wir beraten Sie ausführlich zu Methode und Pflege.", duration: "nach Beratung", price: "ab 150 €" },
      { name: "Kur & Intensivpflege", desc: "Die Intensivkur für strapaziertes oder trockenes Haar – spürbar weicher und glänzender, auch perfekt als Zusatz zu jeder Farbe.", duration: "ca. 15–20 Min.", price: "10 €" },
    ],
  },
];

export const GALLERY_FILTERS = ["Alle", "Schnitt", "Balayage & Highlights", "Hochsteckfrisuren"];

// Vorher/Nachher-Paare für den Vergleichs-Schieber in der Galerie.
// Wird erst angezeigt, wenn echte Paare vorhanden sind: { before, after, altBefore, altAfter, caption }
export const BEFORE_AFTER = [
  {
    before: "/videos/balayage-vorher.mp4",
    after: "/videos/balayage-nachher.mp4",
    altBefore: "Vorher-Video: strapaziertes Haar vor der Balayage",
    altAfter: "Nachher-Video: glänzende kühle Balayage, echtes Ergebnis aus dem Haarstudio Nes",
    caption: "Balayage in Toupier-Technik – echtes Vorher-Nachher-Ergebnis aus unserem Salon",
  },
];

export const GALLERY_ITEMS = [
  { src: IMAGES.balayageReal, category: "Balayage & Highlights", alt: "Echtes Balayage-Ergebnis: karamellfarbene Verläufe, Haarstudio Nes Glessen", real: true },
  { src: IMAGES.highlightsReal, category: "Balayage & Highlights", alt: "Echte Highlights mit feinen Strähnen, Haarstudio Nes Glessen", real: true },
  { src: IMAGES.wavesReal, category: "Schnitt", alt: "Echtes Ergebnis: Schnitt und weiches Wellen-Styling, Haarstudio Nes", real: true },
  { src: IMAGES.mensCutReal, category: "Schnitt", alt: "Echtes Ergebnis: frischer Herrenschnitt von hinten, Haarstudio Nes Glessen", real: true },
  { src: IMAGES.updoReal, category: "Hochsteckfrisuren", alt: "Echte Hochsteckfrisur: eleganter geflochtener Dutt, Haarstudio Nes Glessen", real: true },
];

export const TEAM = [
  { name: "Nes", role: "Inhaberin & Friseurmeisterin", img: IMAGES.nes, about: "Seit 35 Jahren Friseurin – seit 15 Jahren Meisterin.", bio: "Hat das Studio am 19. Februar 2026 übernommen, nachdem sie dort viele Jahre als Mitarbeiterin gearbeitet hat – und steht für einen herzlichen Neuanfang in Glessen. Vom klassischen Schnitt über Farbe und Dauerwelle bis zum Braut-Styling: Nes beherrscht das ganze Handwerk für Damen, Herren und Kinder. Ihre besondere Liebe gilt natürlichen Farbverläufen und eleganten Hochsteckfrisuren – dazu ehrliche, persönliche Beratung.", placeholder: false },
];

export const SERVICE_LINKS = {
  "Haar-Extensions": "/haar-extensions",
  "Lockiges Haar (Schnitt & Pflege)": "/lockiges-haar",
  "Hochsteckfrisur": "/hochsteckfrisuren",
};

export const SERVICE_PAGES = {
  braut: {
    service: "Hochsteckfrisur",
    eyebrow: "Festlich & Braut in Glessen",
    titleLines: ["Der große Tag.", "Die perfekte Frisur."],
    intro: "Hochzeit, Konfirmation, Abschlussball oder Fotoshooting: Nes ist spezialisiert auf elegante Hochsteckfrisuren, die den ganzen Tag halten und auf Fotos strahlen. Mit Probe-Termin, ehrlicher Beratung und ruhiger Atmosphäre – damit der große Moment entspannt beginnt.",
    image: IMAGES.updoReal,
    imageAlt: "Echte Hochsteckfrisur aus dem Haarstudio Nes – eleganter geflochtener Dutt",
    imageCaption: "Festliche Haarkunst Glessen",
    factsTitle: "Für welche Anlässe?",
    factsText: "Ob Braut, Brautjungfer, Konfirmandin oder Geburtstagsgast: Eine Hochsteckfrisur hält, was sie verspricht – vom ersten Foto bis zum letzten Tanz.",
    facts: [
      { t: "Spezialität von Nes", d: "Erfahrung mit Braut-Styling" },
      { t: "Probe-Termin möglich", d: "Varianten vorab testen" },
      { t: "Hält den ganzen Tag", d: "Auch beim Tanzen" },
      { t: "Für fast jedes Haar", d: "Auch mit Haarteilen lösbar" },
    ],
    stepsTitle: "So läuft es bei uns ab",
    stepsNote: "Dauer: ca. 45–75 Minuten. Preis nach Aufwand – den besprechen wir ehrlich im Voraus bei der kostenlosen Beratung.",
    steps: [
      { nr: "01", title: "Beratung", text: "Wir besprechen Anlass, Kleid und deine Wünsche – gerne mit Fotos zur Inspiration." },
      { nr: "02", title: "Probestecken", text: "Auf Wunsch stecken wir vorab eine oder zwei Varianten – so gibt es am großen Tag keine Überraschungen." },
      { nr: "03", title: "Der große Tag", text: "Entspannt ankommen, verwöhnen lassen, strahlend aufbrechen." },
      { nr: "04", title: "Extra-Service", text: "Tipps für Haltbarkeit und kleine Retuschen unterwegs bekommst du mit auf den Weg." },
    ],
    tipsTitle: "Gut vorbereitet zum Termin",
    tips: [
      "Haare am Vortag waschen – frisch gewaschen rutscht leichter",
      "Inspirations-Fotos mitbringen (2–3 reichen)",
      "Zum Anstecken Kleidung mit Knöpfen oder Reißverschluss tragen",
      "Schleier, Blumen oder Haarschmuck zum Probe-Termin mitbringen",
    ],
    faq: [
      { q: "Brauche ich einen Probe-Termin?", a: "Für Bräute empfehlen wir ihn unbedingt – wir testen in Ruhe ein bis zwei Varianten, damit am Hochzeitstag alles sitzt. Für andere Anlässe geht es oft auch ohne." },
      { q: "Wie früh sollte ich buchen?", a: "Für Hochzeiten am besten einige Wochen vorher – in der Hochzeitssaison früher. Für kleinere Anlässe haben wir oft auch kurzfristig etwas frei: einfach anfragen." },
      { q: "Geht eine Hochsteckfrisur auch bei kürzerem Haar?", a: "Meistens ja – mit gekonnter Technik und bei Bedarf Haarteilen. Bei der Beratung schauen wir ehrlich, was mit deinem Haar möglich ist." },
      { q: "Was kostet eine Hochsteckfrisur?", a: "Der Preis richtet sich nach Aufwand und ob ein Probe-Termin dabei ist – wir besprechen das transparent im Voraus, bevor irgendetwas passiert." },
    ],
    ctaTitle: "Dein großer Tag steht an?",
    ctaText: "Sichere dir früh deinen Termin – wir besprechen alles in Ruhe bei einer kostenlosen Beratung.",
    ctaLabel: "Beratungstermin buchen",
  },
  extensions: {
    service: "Haar-Extensions",
    eyebrow: "Länge & Fülle in Glessen",
    titleLines: ["Mehr Länge.", "Mehr Fülle."],
    intro: "Mit hochwertigen Echthaar-Extensions bekommen Sie in wenigen Stunden die Länge und Fülle, die Sie sich wünschen – nahtlos eingearbeitet und unsichtbar. Wir beraten Sie ausführlich zu Methode, Farbe und Pflege, bevor irgendetwas passiert.",
    image: null,
    imageAlt: "",
    imageCaption: "",
    factsTitle: "Für wen sind Extensions geeignet?",
    factsText: "Für alle, die sich längeres oder volleres Haar wünschen – ob nach einem zu kurzen Schnitt, bei feinem Haar oder einfach für den Traum von mehr Mähne. Wichtig ist gesundes Eigenhaar, das die Strähnen tragen kann.",
    facts: [
      { t: "Echthaar-Qualität", d: "Färbe- und stylebar" },
      { t: "Unsichtbar eingearbeitet", d: "Keine sichtbaren Ansätze" },
      { t: "Individuelle Farbanpassung", d: "Perfekt abgestimmt" },
      { t: "Schonende Methoden", d: "Schutz des Eigenhaars" },
    ],
    stepsTitle: "So läuft Ihr Extensions-Termin ab",
    stepsNote: "Dauer: je nach Menge ca. 2–4 Stunden. Richtpreis: ab 150 € – der genaue Preis hängt von Methode, Menge und Haarlänge ab und wird vorab besprochen.",
    steps: [
      { nr: "01", title: "Ausführliche Beratung", text: "Wir besprechen Wunschlänge, Methode und Farbe – ehrlich und ohne Verkaufsdruck." },
      { nr: "02", title: "Farbanpassung", text: "Die Extensions werden exakt auf Ihre Nuance abgestimmt." },
      { nr: "03", title: "Einsetzen", text: "Strähne für Strähne wird sauber und schonend eingearbeitet." },
      { nr: "04", title: "Schnitt & Styling", text: "Zum Schluss bringen wir Extensions und Eigenhaar in eine Form." },
    ],
    tipsTitle: "So pflegen Sie Extensions richtig",
    tips: [
      "Zum Schlafen einen lockeren Zopf flechten",
      "Vom Ansatz zu den Spitzen bürsten, nie umgekehrt",
      "Hitze-Styling mit Schutz und niedriger Temperatur",
      "Regelmäßige Kontroll-Termine im Studio einplanen",
    ],
    faq: [
      { q: "Wie lange halten Extensions?", a: "Je nach Methode mehrere Monate. Da das Eigenhaar wächst, werden die Strähnen regelmäßig hochgesetzt – das besprechen wir bei der Beratung." },
      { q: "Schaden Extensions meinem Haar?", a: "Fachgerecht eingesetzt und richtig gepflegt nicht. Wir wählen die Methode, die zu Ihrem Haar passt, und erklären die Pflege genau." },
      { q: "Kann ich Extensions färben oder stylen?", a: "Ja – wir arbeiten mit Echthaar. Färben, Glätten und Locken sind möglich, idealerweise mit unserer Anleitung." },
      { q: "Was kosten Haar-Extensions?", a: "Als Richtwert ab 150 €, je nach Menge, Länge und Methode. Den verbindlichen Preis erfahren Sie bei der kostenlosen Beratung." },
    ],
    ctaTitle: "Träumen Sie von längerem Haar?",
    ctaText: "Kostenlose Beratung, ehrliche Empfehlung, oft kurzfristig ein Termin frei.",
    ctaLabel: "Beratungstermin buchen",
  },
  locken: {
    service: "Lockiges Haar (Schnitt & Pflege)",
    eyebrow: "Locken-Expertise in Glessen",
    titleLines: ["Locken, die", "perfekt fallen."],
    intro: "Lockiges Haar braucht einen eigenen Schnitt: nass geschnitten, Strähne für Strähne, damit die Form rundum sitzt. Bei uns bekommen Sie genau das – mit ausführlicher Beratung und Zeit für Ihr Haar, oft auch kurzfristig.",
    image: null,
    imageAlt: "",
    imageCaption: "",
    factsTitle: "Warum ein spezieller Lockenschnitt?",
    factsText: "Locken springen nach dem Trocknen – darum schneiden wir sie in ihrer natürlichen Fallweise. So sitzt die Form auch zu Hause, nicht nur frisch frisiert im Salon.",
    facts: [
      { t: "Nassschnitt-Technik", d: "Strähne für Strähne geschnitten" },
      { t: "Nur die Form", d: "Reiner Schnitt, kein Styling-Programm" },
      { t: "Form, die mitwächst", d: "Länger schönes Ergebnis" },
      { t: "Ehrliche Beratung", d: "Was zu Ihren Locken passt" },
    ],
    stepsTitle: "So läuft Ihr Locken-Termin ab",
    stepsNote: "Dauer: ca. 30 Minuten. Richtpreis: ab 35 € – genau nach kostenloser Beratung.",
    steps: [
      { nr: "01", title: "Beratung", text: "Wir schauen uns Ihre Locken an und besprechen, welche Form Sie sich wünschen." },
      { nr: "02", title: "Waschen", text: "Die Haare werden gewaschen und für den Schnitt vorbereitet." },
      { nr: "03", title: "Nassschnitt", text: "Die Locken werden nass geschnitten – Strähne für Strähne in der richtigen Länge." },
      { nr: "04", title: "Föhnen & Feinschliff", text: "Wir prüfen das Ergebnis und feilen an der Form, bis sie rundum sitzt." },
    ],
    tipsTitle: "Gut vorbereitet zum Locken-Termin",
    tips: [
      "Kommen Sie am besten mit ungestylten, luftgetrockneten Locken – so sehen wir bei der Beratung Ihre natürliche Fallweise",
      "Vor dem Termin nicht glätten oder hochstecken",
      "Wunsch-Fotos sind willkommen – sie helfen bei der Beratung",
      "Sagen Sie uns, wie viel Länge bleiben soll – wir schneiden ehrlich und vorsichtig",
    ],
    faq: [
      { q: "Warum schneidet ihr Locken im nassen Zustand?", a: "Nass lassen sich Locken präzise und gleichmäßig schneiden – Strähne für Strähne. Nach dem Föhnen prüfen wir, wie die Form fällt, und arbeiten am Feinschliff." },
      { q: "Meine Locken sind frizzy – hilft ein neuer Schnitt?", a: "Oft ja. Frizz entsteht häufig durch eine unpassende Schnittform. Wir schauen uns Ihre Locken in Ruhe an und schneiden die Form so, dass sie weicher fällt." },
      { q: "Wie oft sollte ich Locken nachschneiden lassen?", a: "Meist reicht alle 8 bis 12 Wochen. Ein guter Lockenschnitt wächst weich heraus und behält länger seine Form." },
      { q: "Was kostet der Lockenschnitt?", a: "Als Richtwert ab 35 €. Den genauen Preis erfahren Sie vorab bei der kostenlosen Beratung." },
    ],
    ctaTitle: "Bereit für definierte Locken?",
    ctaText: "Kostenlose Beratung, Schnitt mit Zeit und Ruhe, oft kurzfristig ein Termin frei.",
    ctaLabel: "Beratungstermin buchen",
  },
};

export const FAQ_BALAYAGE = [
  { q: "Was genau ist Balayage?", a: "Balayage ist eine Freihand-Färbetechnik, bei der die Farbe sanft auf das Haar aufgemalt wird. So entstehen weiche, natürliche Übergänge – ganz ohne Folien und ohne harten Ansatz." },
  { q: "Für wen ist Balayage geeignet?", a: "Für fast alle Haartypen und Haarlängen. Besonders schön wirkt Balayage, wenn Sie einen natürlichen Look möchten, der ohne ständiges Nachfärben des Ansatzes auskommt." },
  { q: "Wie lange dauert ein Balayage-Termin?", a: "Rechnen Sie mit etwa 2 bis 4 Stunden – je nach Haarlänge, Ausgangsfarbe und gewünschtem Ergebnis. Die genaue Zeit besprechen wir bei der Beratung." },
  { q: "Wie lange hält das Ergebnis?", a: "Mehrere Monate. Weil die Übergänge weich verlaufen, wächst Balayage natürlich heraus – ein Ansatz-Nachfärben ist nicht nötig. Ein Glossing frischt den Glanz zwischendurch auf." },
  { q: "Wie pflege ich Balayage zu Hause?", a: "Verwenden Sie farbschonende Shampoos und eine wöchentliche Kur. Hitzeschutz vor dem Styling hält die Nuance länger frisch. Bei Ihrem Termin geben wir Ihnen passende Pflegeempfehlungen mit." },
  { q: "Was kostet eine Balayage?", a: "Der Preis richtet sich nach Haarlänge und Aufwand – als Richtwert ab 120 €. Den genauen Preis nennen wir Ihnen vorab bei der kostenlosen Beratung." },
];

export const SEO = {
  "/": { title: "Friseur Glessen | Haarstudio Nes – Balayage & Schnitt", desc: "Haarstudio Nes in Glessen: Balayage, Highlights, Schnitt & Extensions. Kurze Wartezeiten, kurzfristige Termine, persönliche Beratung. Jetzt Termin anfragen." },
  "/leistungen": { title: "Leistungen & Preise | Haarstudio Nes Glessen", desc: "Alle Leistungen von Haarstudio Nes in Glessen: Schnitt, Farbe, Balayage, Extensions & mehr – mit Richtpreisen und Termin-Anfrage." },
  "/balayage": { title: "Balayage Glessen | Haarstudio Nes – Farbexpertin", desc: "Balayage in Glessen: natürliche Farbverläufe ohne Ansatzstress. Ablauf, Dauer, Pflege-Tipps & FAQ. Beratungstermin bei Haarstudio Nes vereinbaren." },
  "/frisuren": { title: "Frisuren & Wissen | Haarstudio Nes Glessen", desc: "Einfach erklärt: Balayage, Hochsteckfrisuren, Locken, Extensions, Schnitt & Dauerwelle – was es ist und was es Ihrem Haar bringt. Haarstudio Nes Glessen." },
  "/team": { title: "Über Nes | Haarstudio Nes – Friseurin Glessen", desc: "Lernen Sie Nes kennen: die neue Inhaberin des Haarstudio Nes in Glessen. Persönliche Beratung, ehrliche Empfehlung, entspannte Atmosphäre." },
  "/galerie": { title: "Galerie | Haarstudio Nes Glessen – Haarkunst", desc: "Einblicke ins Haarstudio Nes in Glessen: Balayage, Schnitte, Locken, Extensions und mehr – Vorher-Nachher-Eindrücke aus dem Salon." },
  "/karriere": { title: "Friseur Jobs Glessen | Karriere bei Haarstudio Nes", desc: "Werde Teil vom Haarstudio Nes in Glessen: Stellen für Friseur/in (Voll- & Teilzeit) und Auszubildende. Familiäres Team, geregelte Zeiten." },
  "/kontakt": { title: "Kontakt & Termin | Haarstudio Nes Glessen", desc: "Termin anfragen bei Haarstudio Nes, Heidenpfuhl 7, 50129 Glessen. Telefon 02238 43 770. Auch kurzfristige Termine – wir rufen zurück." },
  "/haar-extensions": { title: "Haar-Extensions Glessen | Haarstudio Nes", desc: "Echthaar-Extensions in Glessen: mehr Länge und Fülle, unsichtbar eingearbeitet. Ausführliche Beratung bei Haarstudio Nes – Termin anfragen." },
  "/lockiges-haar": { title: "Locken Friseur Glessen | Haarstudio Nes", desc: "Locken-Spezialschnitt in Glessen: nass geschnitten, Strähne für Strähne – die Form, die zu Ihren Locken passt. Termin bei Haarstudio Nes anfragen." },
  "/hochsteckfrisuren": { title: "Hochsteckfrisuren & Braut Glessen | Haarstudio Nes", desc: "Hochsteckfrisuren in Glessen für Hochzeit & Feste – Spezialität von Nes. Mit Probe-Termin und ehrlicher Beratung. Jetzt Termin anfragen." },
};
